import { SKELETON_KEY, SKELETON_KEY_DATE, SKELETON_KEY_NUMBER } from './skeletonFactory';

export function skeletonReaderOperator() {
  return {
    id: SKELETON_KEY,
    name: SKELETON_KEY
  };
}

export function skeletonReaderRequest(operatorsNum = 5) {
  return {
    id: SKELETON_KEY,
    reader: SKELETON_KEY,
    product: SKELETON_KEY,
    requestDate: SKELETON_KEY_DATE,
    receptionDate: SKELETON_KEY_DATE,
    requestStatus: SKELETON_KEY,
    requestType: SKELETON_KEY,
    ringAmount: SKELETON_KEY_NUMBER,
    boxesAmountToRead: SKELETON_KEY_NUMBER,
    responseFileUrl: SKELETON_KEY,
    readingStartDate: SKELETON_KEY_DATE,
    readingEndDate: SKELETON_KEY_DATE,
    processingTime: SKELETON_KEY_NUMBER,
    errors: SKELETON_KEY,
    observations: SKELETON_KEY,
    productionDate: SKELETON_KEY_DATE,
    operators: Array(operatorsNum).fill(skeletonReaderOperator())
  };
}
